import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  menuOpen = false;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  exit() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
